import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Observable} from 'rxjs';
import {ComponentPortal} from '@angular/cdk/portal';
import {ComponentsArray, RightBottomIconService} from '../../right-bottom-icon.service';
import {map} from 'rxjs/operators';

@Component({
    selector: 'lib-button-icons',
    templateUrl: './button-icons.component.html',
    styleUrls: ['./button-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonIconsComponent implements OnInit {
  icons$: Observable<Array<ComponentsArray>>;
  sortedIcons$: Observable<Array<ComponentPortal<any>>>;

  constructor(iconsService: RightBottomIconService) {
    this.icons$ = iconsService.getComponents();
    this.sortedIcons$ = this.icons$.pipe(map(all => {
      return all.sort((a, b) => a.priority - b.priority).map(({component}) => (component));
    }));
  }

  ngOnInit(): void {
  }

}
